import React, {useEffect} from 'react';
import Router from "next/router";
import Shomal from "../../../pages/properties/landing/shomal";
import Mashhad from "../../../pages/properties/landing/mashhad";
import Tehran from "../../../pages/properties/landing/tehran";
import NorthCities from "../../../pages/properties/landing/north_cities";
import HolyShrineLanding from "../../../pages/properties/landing/holy_shrine";
import TehranHomeLanding from "../../../pages/home/landing/tehran";
import MashhadHomeLanding from "../../../pages/home/landing/mashhad";
import PardisHomeLanding from "../../../pages/home/landing/pardis";
import CitiesHomeLanding from "../../../pages/home/landing/cities";
import {isEmpty} from "@helpers/helpers";
import {inArray} from "../../helpers/arrays";
import {northCitiesLandingUrl} from "../property/landing/north_cities";

const landingUrls = [
    '/املاک-تهران',
    '/املاک-مشهد',
    '/املاک-پردیس',
    '/املاک-مشهد/خرید-فروش-آپارتمان',
    '/املاک-مشهد/خرید-فروش-آپارتمان/نزدیک-حرم-امام-رضا',
    '/املاک-تهران/خرید-فروش-آپارتمان',
    '/املاک-شمال/خرید-فروش-ویلا',
    ...northCitiesLandingUrl()
];

const ShowSearchLandings = ({pageTitle, showLanding, searchNavbarRef, landingData, handleBackFromLanding, selectedCityId, isBadeSaba = false, setShowLanding, setSkeleton, setContactInfo}) => {

    const landingsComponents = {
        shomal: Shomal,
        mashhad: Mashhad,
        tehran: Tehran,
        holyShrine: HolyShrineLanding,
        north_city: NorthCities,
        tehran_home: TehranHomeLanding,
        mashhad_home: MashhadHomeLanding,
        pardis_home: PardisHomeLanding,
        cities_home: CitiesHomeLanding,
    };

    const Component = landingsComponents[showLanding];

    var showLandingFlag = true;

    useEffect(() => {
        const handleStart = url => {
            const decodeUrl = decodeURI(url);
            const urlSplit = decodeUrl.split('/');

            if (showLandingFlag && url !== Router.asPath && !inArray(decodeURI(url), landingUrls) && !(urlSplit.length === 2 && decodeUrl.indexOf('املاک-') !== -1)) {
                showLandingFlag = false;
                setShowLanding('');
                setSkeleton(true);
            } else {
                showLandingFlag = true;
            }
        };

        Router.events.on("routeChangeStart", handleStart);

        return () => {
            Router.events.off("routeChangeStart", handleStart);
        };
    }, [showLanding]);

    return (
        <Component
            pageTitle={pageTitle}
            handleBackFromLanding={handleBackFromLanding}
            city_id={selectedCityId}
            mostActiveRealtorsLists={(!isEmpty(landingData) && !isEmpty(landingData.mostActiveRealtorsLists)) ? landingData.mostActiveRealtorsLists : null}
            cityAreasWidget={(!isEmpty(landingData) && !isEmpty(landingData.cityAreasWidget)) ? landingData.cityAreasWidget : null}
            cityPropertiesWidget={(!isEmpty(landingData) && !isEmpty(landingData.cityPropertiesWidget)) ? landingData.cityPropertiesWidget : null}
            citySalePropertiesWidget={(!isEmpty(landingData) && !isEmpty(landingData.citySalePropertiesWidget)) ? landingData.citySalePropertiesWidget : null}
            cityRentPropertiesWidget={(!isEmpty(landingData) && !isEmpty(landingData.cityRentPropertiesWidget)) ? landingData.cityRentPropertiesWidget : null}
            cityHasVideoPropertiesWidget={(!isEmpty(landingData) && !isEmpty(landingData.cityHasVideoPropertiesWidget)) ? landingData.cityHasVideoPropertiesWidget : null}
            specialCitiesLists={(!isEmpty(landingData) && !isEmpty(landingData.specialCities)) ? landingData.specialCities : null}
            northCityData={(!isEmpty(landingData) && !isEmpty(landingData.getNorthCityData)) ? landingData.getNorthCityData : null}
            faqsList={(!isEmpty(landingData) && !isEmpty(landingData.faqsList) && !process.browser) ? landingData.faqsList : null}
            ssrBrandingText={(!isEmpty(landingData) && !isEmpty(landingData.ssrBrandingText) && !process.browser) ? landingData.ssrBrandingText : null}
            searchNavbarRef={searchNavbarRef}
            isBadeSaba={isBadeSaba}
            setContactInfo={setContactInfo}
        />
    )
};

function propsAreEqual(prevProps, nextProps) {
    return (prevProps.showLanding === nextProps.showLanding && prevProps.pageTitle === nextProps.pageTitle);
}

export default React.memo(ShowSearchLandings, propsAreEqual);
